module.exports = __webpack_public_path__ + "img/logo_gray.e4c264e5.png";